import { render, staticRenderFns } from "./WorkshopsWorkshopDetails.vue?vue&type=template&id=0e4bf864&scoped=true&"
import script from "./WorkshopsWorkshopDetails.vue?vue&type=script&lang=ts&"
export * from "./WorkshopsWorkshopDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4bf864",
  null
  
)

export default component.exports